/* Keep Warehouse's mobile search panel stable without replacing its autocomplete. */
(function () {
  'use strict';

  if (window.__rudcaHeaderSearchInstalled) return;
  window.__rudcaHeaderSearchInstalled = true;

  var wrapperSelector = '.header__search-bar-wrapper';
  var inputSelector = '.search-bar__input:not([type="hidden"])';
  var openClass = 'rudca-search-panel-open';
  var states = new WeakMap();
  var composingInputs = new WeakSet();

  function isPhone() {
    return window.matchMedia('screen and (max-width: 640px)').matches;
  }

  function wrapperFor(node) {
    return node && node.closest ? node.closest(wrapperSelector) : null;
  }

  function toggleFor(wrapper) {
    var section = wrapper.closest('[data-section-type="header"]');
    return section && section.querySelector('[data-action="toggle-search"]');
  }

  function setPanel(wrapper, open) {
    wrapper.classList.toggle(openClass, open);
    var toggle = toggleFor(wrapper);
    if (toggle) toggle.setAttribute('aria-expanded', String(open));
  }

  function focusWithoutScroll(element) {
    if (element) element.focus({ preventScroll: true });
  }

  function hideBlankResults(wrapper) {
    var input = wrapper.querySelector(inputSelector);
    if (!isPhone() || !input || input.value.trim() !== '') return;

    var results = wrapper.querySelector('.search-bar__results');
    var inner = wrapper.querySelector('.search-bar__results-inner');
    var form = wrapper.querySelector('.search-bar');
    if (results && results.getAttribute('aria-hidden') !== 'true') {
      results.setAttribute('aria-hidden', 'true');
    }
    // A response body already in flight can finish after Clear. Never leave its
    // links available to Warehouse's Tab handler while the query is blank.
    if (inner && inner.firstChild) inner.textContent = '';
    if (form) {
      form.classList.remove('is-loading');
      if (!wrapper.querySelector('.search-bar__menu-wrapper')) {
        form.classList.remove('is-expanded');
      }
    }
  }

  function watchBlankResults(wrapper) {
    if (states.has(wrapper)) return;
    var results = wrapper.querySelector('.search-bar__results');
    if (!results) return;
    var observer = new MutationObserver(function () { hideBlankResults(wrapper); });
    observer.observe(results, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['aria-hidden']
    });
    states.set(wrapper, observer);
  }

  function restoreQueryInput(wrapper) {
    var input = wrapper.querySelector(inputSelector);
    if (!input) return null;
    // Warehouse swaps the visible q name onto a hidden clone for normalization.
    // Repair only those identifiable clones before a retry or a restored page.
    wrapper.querySelectorAll('.search-bar__input[type="hidden"][name="q"]').forEach(function (clone) {
      clone.remove();
    });
    input.setAttribute('name', 'q');
    return input;
  }

  function trackComposition(event) {
    var input = event.target;
    if (!input.matches || !input.matches(inputSelector) || !wrapperFor(input)) return;
    if (event.type === 'compositionstart') composingInputs.add(input);
    else composingInputs.delete(input);
  }

  document.addEventListener('compositionstart', trackComposition, true);
  document.addEventListener('compositionend', trackComposition, true);

  // Capture before Warehouse's wrapper-level submit delegate: prevent the native
  // clone mutation as well as navigation for an empty/whitespace-only query.
  document.addEventListener('submit', function (event) {
    var wrapper = wrapperFor(event.target);
    if (!wrapper || !event.target.matches('form.search-bar')) return;
    var input = wrapper.querySelector(inputSelector);
    if (!input) return;
    // IME confirmation must not navigate or reach Warehouse's query cloning.
    // Ordinary keyboard Search/Go submits have no submitter and remain native.
    if (composingInputs.has(input) || event.isComposing) {
      event.preventDefault();
      event.stopImmediatePropagation();
      return;
    }
    restoreQueryInput(wrapper);

    if (input.value.trim() === '') {
      event.preventDefault();
      event.stopImmediatePropagation();
      if (isPhone()) {
        watchBlankResults(wrapper);
        setPanel(wrapper, true);
        hideBlankResults(wrapper);
      }
      focusWithoutScroll(input);
      return;
    }

    // Preserve native nonblank submission, including product_type and the
    // existing cod-liver normalization. Recover only if another handler cancels.
    window.setTimeout(function () {
      if (event.defaultPrevented && wrapper.isConnected) restoreQueryInput(wrapper);
    }, 0);
  }, true);

  // Bubble on document deliberately runs AFTER the existing header delegates.
  document.addEventListener('click', function (event) {
    var control = event.target.closest && event.target.closest('[data-action]');
    if (!control || !isPhone()) return;
    var action = control.getAttribute('data-action');
    var wrapper = wrapperFor(control);

    if (action === 'toggle-search') {
      var section = control.closest('[data-section-type="header"]');
      wrapper = section && section.querySelector(wrapperSelector);
      if (!wrapper) return;
      watchBlankResults(wrapper);
      var open = wrapper.classList.contains('is-visible');
      setPanel(wrapper, open);
      if (!open && wrapper.classList.contains('is-fixed')) {
        // The native magnifier toggles visibility but does not unfix the form.
        var close = wrapper.querySelector('[data-action="unfix-search"]');
        if (close) close.click();
      }
      if (open) {
        hideBlankResults(wrapper);
        var currentInput = restoreQueryInput(wrapper);
        // Closing invalidates pending native requests. Reopening a retained
        // query should fetch it again instead of waiting for another keystroke.
        if (currentInput && currentInput.value.trim() !== '') {
          currentInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
      }
    } else if (wrapper && action === 'unfix-search') {
      setPanel(wrapper, false);
      var toggle = toggleFor(wrapper);
      // Native Close only unfixes. Use its native toggle too, so private
      // isSearchOpen and is-visible agree and the next magnifier click reopens.
      if (toggle && wrapper.classList.contains('is-visible')) toggle.click();
      if (wrapper.contains(document.activeElement)) document.activeElement.blur();
      focusWithoutScroll(toggle);
    } else if (wrapper && action === 'clear-input') {
      var input = restoreQueryInput(wrapper);
      if (!input) return;
      watchBlankResults(wrapper);
      setPanel(wrapper, true);
      hideBlankResults(wrapper);
      // Native clear does not emit input; route the cleared value through its
      // existing debounce rather than introducing another request owner.
      input.dispatchEvent(new Event('input', { bubbles: true }));
      focusWithoutScroll(input);
    }
  });

  document.addEventListener('focusin', function (event) {
    if (!isPhone() || !event.target.matches(inputSelector)) return;
    var wrapper = wrapperFor(event.target);
    if (!wrapper) return;
    watchBlankResults(wrapper);
    setPanel(wrapper, true);
    hideBlankResults(wrapper);
  });

  document.addEventListener('input', function (event) {
    if (!isPhone() || !event.target.matches(inputSelector)) return;
    var wrapper = wrapperFor(event.target);
    if (!wrapper) return;
    watchBlankResults(wrapper);
    hideBlankResults(wrapper);
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape' || event.defaultPrevented || event.isComposing || !isPhone()) return;
    var wrapper = wrapperFor(event.target) || document.querySelector(wrapperSelector + '.' + openClass);
    if (!wrapper || !wrapper.classList.contains(openClass)) return;
    var close = wrapper.querySelector('[data-action="unfix-search"]');
    if (!close) return;
    event.preventDefault();
    close.click();
  });

  // Back/forward closes an open mobile panel without adding history entries.
  window.addEventListener('popstate', function () {
    if (!isPhone()) return;
    document.querySelectorAll(wrapperSelector + '.' + openClass).forEach(function (wrapper) {
      var close = wrapper.querySelector('[data-action="unfix-search"]');
      if (close) close.click();
    });
  });

  // A restored BFCache page can still contain Warehouse's temporary hidden q.
  window.addEventListener('pageshow', function () {
    document.querySelectorAll(wrapperSelector).forEach(restoreQueryInput);
  });

  document.addEventListener('shopify:section:unload', function (event) {
    event.target.querySelectorAll(wrapperSelector).forEach(function (wrapper) {
      var observer = states.get(wrapper);
      if (observer) observer.disconnect();
      states.delete(wrapper);
    });
  });
}());
